import axios from 'axios'
import Qs from 'qs'

import { hashHistory } from 'react-router'

import home from './home'
import authorization from './authorization'
import articleDetails from './articleDetails'
import wx from './wx'

// const host = 'http://192.168.1.6/icu/index.php/'
const host = 'http://client.rup-china.com/icu/index.php/'

// 实例化 ajax请求对象
const ajaxinstance = axios.create({
  baseURL: host,
  timeout: 5000,
//   headers: {
//     // responseType: 'json',
//     // 'Content-Type': 'application/json'
//   }
  transformRequest: [function (data = {}) {
    data.openid = window.sessionStorage.getItem('openid')
    data = Qs.stringify(data)
    console.log(data)
    return data
  }],
  headers:{ 'Content-Type':'application/x-www-form-urlencoded' }

})

// 添加拦截器，处理 公用请求参数，和通用请求头部
ajaxinstance
  .interceptors
  .request
  .use((config) => {
    // TODO

    return config
  }, (error) => {
    Promise.reject(error)
  })

// 请求响应拦截器
ajaxinstance
  .interceptors
  .response
  .use((response) => {
    // TODO
    return response.data
  }, (error) => {
    let isLogin = true

    // TODO 登录鉴权
    if (!isLogin) {
      hashHistory.push('/login')
    }
    return Promise.reject(error)
  })

/**
 * [API api接口封装]
 * @type {Object}
 */
const API = {
  ...home(ajaxinstance),
  ...authorization(ajaxinstance),
  ...articleDetails(ajaxinstance),
  ...wx(ajaxinstance)
}

export default API



// WEBPACK FOOTER //
// ./src/common/apis/index.js